<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-0 pt-5 pt-md-3"></base-header>
    <div class="container-fluid mt-3">
      <tabs :fill="false" class="flex-column flex-md-row">
        <div>
            <tab-pane>
              <span slot="title">
                  <i class="ni ni-cloud-upload-96"></i>
                  Categories
              </span>

              <!-- all categry table -->
              <div class="row mb-5">
                <div class="col">
                  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
                    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
                      <div class="row align-items-center">
                        <div class="col">
                          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                            Business Categories
                          </h3>
                        </div>
                        <div class="col text-right">
                          <base-button type="primary" size="sm" @click="openaddcategory()" icon="fa fa-plus">Add new category</base-button>
                        </div>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <base-table class="table align-items-center table-flush" :class="type === 'dark' ? 'table-dark': ''" :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'" tbody-classes="list" :data="sortArrays(categoryData)">
                        <template slot="columns">
                          <th>Name</th>
                          <th>Name in Arabic</th>
                          <th>Status</th>
                          <th></th>
                        </template>
                        <template slot-scope="{row}">
                            <td class="budget">
                              <p style="text-transform: capitalize;">{{row.business_category_name}}</p>
                            </td>
                            
                            <td class="budget">
                              <p style="text-transform: capitalize;">{{row.business_category_name_ar}}</p>
                            </td>
                            <td class="budget">
                              <p style="display: block;vertical-align: middle;margin-top: 7px;">{{row.status}}</p>
                            </td>
                            <td class="text-right">
                              <base-button type="primary" size="sm" @click="opencategory(row)" icon="fa fa-pencil">Edit</base-button>
                              <base-button type="danger" size="sm" @click="deletecategory(row)" icon="fa fa-pencil">Delete</base-button>
                              <a type="primary" size="sm" :href="'#/viewbusinesscategory/'+row._id+'/'+row.business_category_id" icon="fa fa-info">View</a>
                            </td>
                        </template>
                      </base-table>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>

            <!-- brands -->
            <!-- <tab-pane>
              <span slot="title">
                  <i class="ni ni-cloud-upload-96"></i>
                  City
              </span> -->

              <!-- all Brand table -->
              <!-- <div class="row mb-5">
                <div class="col">
                  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
                    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
                      <div class="row align-items-center">
                        <div class="col">
                          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                            All City
                          </h3>
                        </div>
                        <div class="col text-right">
                          <base-button type="primary" size="sm" icon="fa fa-plus" @click="openaddcity()">Add new city</base-button>
                        </div>
                      </div>
                    </div>
                    <div class="table-responsive">
                      <base-table class="table align-items-center table-flush" :class="type === 'dark' ? 'table-dark': ''" :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'" tbody-classes="list" :data="sortbrands(cityData)">
                        <template slot="columns">
                          <th>Name</th>
                          <th>Name Arabic</th>
                          <th></th>
                        </template>
                        <template slot-scope="{row}">
                            <td class="budget">
                              <p style="text-transform: capitalize;">{{row.filter_name}}</p>
                            </td>
                            <td class="budget">
                              <p style="display: block;vertical-align: middle;margin-top: 7px;">{{row.filter_name_ar}}</p>
                            </td>
                            <td class="text-right">
                              <base-button type="primary" size="sm" @click="opencity(row)" icon="fa fa-pencil">Edit</base-button>
                              <base-button type="danger" size="sm" @click="deletecity(row)" icon="fa fa-pencil">Delete</base-button>
                            </td>
                        </template>
                      </base-table>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane> -->
        </div>
      </tabs>
    </div>
    <!-- modal add Category  -->
    <modal :show.sync="model.addcategory">
          <h6 slot="header" class="modal-title" id="modal-title-default">Add</h6>
                    <template>
                    <form @submit.prevent>
                     <div class="">
                      <div class="row">
                        <div class="col-lg-12">
                            <base-input alternative="" label="Category Name" placeholder="Category Name" input-classes="form-control-alternative" v-model="model.business_category_name" />
                        </div>
                        <div class="col-lg-12">
                            <base-input alternative="" label="Category Name Arabic" placeholder="Category Name Arabic" input-classes="form-control-alternative" v-model="model.business_category_name_ar" />
                        </div>
                        <div class="col-lg-12">
                            <base-input alternative="" label="Search Tags (not shown to visitors)" placeholder="e.g. ceramics, porcelain, marble" input-classes="form-control-alternative" v-model="model.business_category_tags" />
                            <small class="text-muted">Comma-separated alternate words people might search for instead of the category name.</small>
                        </div>
                      </div>
                      <div class="row mt-3 mb-4">
                        <div class="col-lg-12.">
                           <label class="form-control-label">Status</label>
                            <select  v-model="model.status" aria-describedby="addon-right addon-left" class="form-control form-control-alternative" autocomplete="off">
                                <option>approved</option>
                                <option>disapprove</option>
                           </select>
                        </div>
                      </div>
                     </div>
                    </form>
                    </template>

          <template slot="footer">
              <base-button type="primary" id="updatebtn" v-on:click="savecategory()">Save changes</base-button>
              <base-button type="link" class="ml-auto" @click="model.addcategory = false">Close
              </base-button>
          </template>
    </modal>
        <!-- modal edit category  -->
    <modal :show.sync="modals.editcategory">
          <h6 slot="header" class="modal-title" id="modal-title-default">Edit</h6>
                    <template>
                    <form @submit.prevent>
                     <div class="">
                      <div class="row">
                        <div class="col-lg-12">
                            <base-input alternative="" label="Category Name" placeholder="Category Name" input-classes="form-control-alternative" v-model="modals.business_category_name" />
                        </div>
                        <div class="col-lg-12">
                            <base-input alternative="" label="Category Name Arabic" placeholder="Category Name Arabic" input-classes="form-control-alternative" v-model="modals.business_category_name_ar" />
                        </div>
                        <div class="col-lg-12">
                            <base-input alternative="" label="Search Tags (not shown to visitors)" placeholder="e.g. ceramics, porcelain, marble" input-classes="form-control-alternative" v-model="modals.business_category_tags" />
                            <small class="text-muted">Comma-separated alternate words people might search for instead of the category name.</small>
                        </div>
                      </div>
                      <div class="row mt-3 mb-4">
                        <div class="col-lg-12.">
                           <label class="form-control-label">Status</label>
                            <select  v-model="modals.status" aria-describedby="addon-right addon-left" class="form-control form-control-alternative" autocomplete="off">
                                <option>approved</option>
                                <option>disapprove</option>
                           </select>
                        </div>
                      </div>
                     </div>
                    </form>
                    </template>

          <template slot="footer">
              <base-button type="primary" id="updatebtn1" v-on:click="updatecategory()">Save changes</base-button>
              <base-button type="link" class="ml-auto" @click="modals.editcategory = false">Close
              </base-button>
          </template>
    </modal>
    <!-- modal add city  -->
    <!-- <modal :show.sync="citymodel.addcity">
          <h6 slot="header" class="modal-title" id="modal-title-default">Add</h6>
                    <template>
                    <form @submit.prevent>
                     <div class="">
                      <div class="row">
                        <div class="col-lg-12">
                            <base-input alternative="" label="City Name" placeholder="City Name" input-classes="form-control-alternative" v-model="citymodel.filter_name" />
                        </div>
                        <div class="col-lg-12">
                            <base-input alternative="" label="City Name Arabic" placeholder="City Name Arabic" input-classes="form-control-alternative" v-model="citymodel.filter_name_ar" />
                        </div>
                      </div>
                     </div>
                    </form>
                    </template>

          <template slot="footer">
              <base-button type="primary" id="updatebtn3" v-on:click="savecity()">Save changes</base-button>
              <base-button type="link" class="ml-auto" @click="citymodel.addcity = false">Close
              </base-button>
          </template>
    </modal>

    <modal :show.sync="citymodals.editcity">
      <h6 slot="header" class="modal-title" id="modal-title-default">Edit</h6>
      <template>
      <form @submit.prevent>
        <div class="">
        <div class="row">
          <div class="col-lg-12">
              <base-input alternative="" label="City Name" placeholder="City Name" input-classes="form-control-alternative" v-model="citymodals.filter_name" />
          </div>
          <div class="col-lg-12">
              <base-input alternative="" label="City Name Arabic" placeholder="City Name Arabic" input-classes="form-control-alternative" v-model="citymodals.filter_name_ar" />
          </div>
        </div>
        </div>
      </form>
      </template>
      <template slot="footer">
          <base-button type="primary" id="updatebtn4" v-on:click="updatecity()">Save changes</base-button>
          <base-button type="link" class="ml-auto" @click="citymodals.editcity = false">Close
          </base-button>
      </template>
    </modal> -->
  </div>
</template>

<script>
  import axios from "axios";
  import VueSwal from 'vue-swal';
  export default {
    name: 'tables',
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        categoryData:[],
        // cityData:[],
        auth : {
          headers: { 'Content-Type':'application/x-www-form-urlencoded',
          'x-api-key':'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjoidGVzdHVzZXIiLCJpYXQiOjE1NDk4OTE1ODQsImV4cCI6MTU4MTQyNzU4NH0.LXjF7LPkGplQj6nWnEgmdyK7GNceoiihf4mKoAmQQqc'}
        },
        modals:{
          editcategory:false,
          business_category_name:'',
          business_category_id:'',
          business_category_name_ar:'',
          business_category_tags:'',
          status:'approved',
          created_by:'Admin'
          },
        model:{
          addcategory:false,
          business_category_name:'',
          business_category_id:'',
          business_category_name_ar:'',
          business_category_tags:'',
          status:'approved',
          created_by:'Admin'
          },
        // citymodals:{
        //   editcity:false,
        //   filter_name:'',
        //   filter_name_ar:'',
        //   filter_id:'',
        //   optype:'',
        //   created_by:'Admin'
        //   },
        // citymodel:{
        //   addcity:false,
        //   filter_name:'',
        //   filter_name_ar:'',
        //   filter_id:'',
        //   optype:'Add',
        //   created_by:'Admin'
        // },
      }
    },
    mounted () {

      const querystring = require('querystring');
      console.log(this.auth);
      
      axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_business_category',querystring.stringify({status:'approved',offset:'0', limit:'50'}),this.auth)
      .then(response => {
        console.log(response);
        if(response.data.details){
        this.categoryData=response.data.details;
        }
            
      })

      // axios
      // .post(process.env.VUE_APP_API_ENDPOINT+'read_business_filter_all', this.auth)
      // .then(response => {
      //   console.log(response);
      //   if(response.data.details){
      //     this.cityData=response.data.details;
      //   }   
      // })
    },
    methods: {

    opencategory: function(tcdata) {
       console.log(tcdata);
       this.modals.editcategory = true;
       this.modals.business_category_id=tcdata.business_category_id;
       this.modals.business_category_name=tcdata.business_category_name;
       this.modals.business_category_name_ar=tcdata.business_category_name_ar;
       this.modals.business_category_tags=(tcdata.business_category_tags || []).join(', ');
       this.modals.status=tcdata.status;
       this.modals.created_by=tcdata.created_by;
       console.log(this.modals);

    },
    openaddcategory: function() {
       this.model.addcategory = true;
    },
    // openaddcity: function() {
    //    this.citymodel.addcity = true;
    // },
    // opencity: function(tcdata) {
    //    console.log("tcdata: ",tcdata);
    //    this.citymodals.editcity = true;
    //    this.citymodals.filter_name=tcdata.filter_name;
    //    this.citymodals.filter_name_ar=tcdata.filter_name_ar;
    //    this.citymodals.filter_id=tcdata.filter_id;
    //    this.citymodals.optype='Add';
    //    console.log(this.citymodals);
    // },

    savecategory() {
      const querystring = require('querystring');
       axios.post(process.env.VUE_APP_API_ENDPOINT+'create_business_category',querystring.stringify({business_category_name : this.model.business_category_name,business_category_name_ar:this.model.business_category_name_ar,business_category_tags:this.model.business_category_tags,status:this.model.status,created_by:this.model.created_by}),this.auth).then(response => {
          console.log(response);
          this.message=response.data.message;
          document.getElementById("updatebtn").classList.remove('btn-primary');
          document.getElementById("updatebtn").classList.add('btn-success');
          document.getElementById("updatebtn").innerHTML=this.message;
          setTimeout(function(){
          document.getElementById("updatebtn").classList.remove('btn-success');
          document.getElementById("updatebtn").classList.add('btn-primary');
          document.getElementById("updatebtn").innerHTML="Update";
          window.location.reload()
          }, 2000);
        })

    },
    updatecategory() {
      const querystring = require('querystring');
       axios.post(process.env.VUE_APP_API_ENDPOINT+'update_business_category',querystring.stringify({business_category_id:this.modals.business_category_id,business_category_name : this.modals.business_category_name,business_category_name_ar:this.modals.business_category_name_ar,business_category_tags:this.modals.business_category_tags,status:this.modals.status,created_by:this.modals.created_by}),this.auth).then(response => {
        console.log(response);
        this.message=response.data.message;
        document.getElementById("updatebtn1").classList.remove('btn-primary');
        document.getElementById("updatebtn1").classList.add('btn-success');
        document.getElementById("updatebtn1").innerHTML=this.message;
        setTimeout(function(){
        document.getElementById("updatebtn1").classList.remove('btn-success');
        document.getElementById("updatebtn1").classList.add('btn-primary');
        document.getElementById("updatebtn1").innerHTML="Update";
        window.location.reload()
      }, 2000);
      })

    },
    deletecategory(row) {
      const querystring = require('querystring');
        swal({
            title: 'Are you sure?',
            text: "wan't to delete",
            icon: 'warning',
            buttons: {cancel: true,confirm: true,}
        }).then((result) => { 
          if (result) {
            console.log('result cloud',result)
            axios.post(process.env.VUE_APP_API_ENDPOINT+'delete_business_category/',querystring.stringify({business_category_id:row.business_category_id,created_by:this.model.created_by}),this.auth)
          .then(response => {
            console.log(response);
            swal({
              title:'Deleted!',
              text: 'Your file has been deleted.',
              icon:'success',
             }).then((result) => {
              console.log(result)
              window.location.reload()
            })
            })
           }
        });
    },
    // savecity() {
    //   const querystring = require('querystring');
    //   console.log(this.citymodel);
    //    axios.post(process.env.VUE_APP_API_ENDPOINT+'create_business_filter',querystring.stringify({filter_id:this.citymodel.filter_id,filter_name : this.citymodel.filter_name,filter_name_ar:this.citymodel.filter_name_ar,optype:this.citymodel.optype,created_by:this.citymodel.created_by}),this.auth).then(response => {
    //       console.log(response);
    //       this.message=response.data.message;
    //       document.getElementById("updatebtn3").classList.remove('btn-primary');
    //       document.getElementById("updatebtn3").classList.add('btn-success');
    //       document.getElementById("updatebtn3").innerHTML=this.message;
    //       setTimeout(function(){
    //       document.getElementById("updatebtn3").classList.remove('btn-success');
    //       document.getElementById("updatebtn3").classList.add('btn-primary');
    //       document.getElementById("updatebtn3").innerHTML="Update";
    //       window.location.reload()
    //       }, 2000);
    //     })

    // },   
    // updatecity() {
    //   const querystring = require('querystring');
    //   console.log(this.citymodals);
    //    axios.post(process.env.VUE_APP_API_ENDPOINT+'update_business_filter',querystring.stringify({filter_id:this.citymodals.filter_id,filter_name : this.citymodals.filter_name,filter_name_ar:this.citymodals.filter_name_ar,created_by:this.citymodals.created_by}),this.auth).then(response => {
    //     console.log(response);
    //     this.message=response.data.message;
    //     document.getElementById("updatebtn4").classList.remove('btn-primary');
    //     document.getElementById("updatebtn4").classList.add('btn-success');
    //     document.getElementById("updatebtn4").innerHTML=this.message;
    //     setTimeout(function(){
    //       document.getElementById("updatebtn4").classList.remove('btn-success');
    //       document.getElementById("updatebtn4").classList.add('btn-primary');
    //       document.getElementById("updatebtn4").innerHTML="Update";
    //       window.location.reload()
    //     }, 2000);
    //   })
    // },
    // deletecity(row) {
    //   const querystring = require('querystring');

    //     swal({
    //         title: 'Are you sure?',
    //         text: "want to delete",
    //         icon: 'warning',
    //         buttons: {cancel: true,confirm: true,}
    //     }).then((result) => { 
    //       if (result) {
    //         console.log('result cloud',result)
    //         axios.post(process.env.VUE_APP_API_ENDPOINT+'delete_business_filter/',querystring.stringify({filter_id:row.filter_id,filter_name : row.filter_name,filter_name_ar:row.filter_name_ar,optype:'Remove',created_by:row.created_by}),this.auth)
    //       .then(response => {
    //         console.log(response);
    //         swal({
    //           title:'Deleted!',
    //           text: 'Your file has been deleted.',
    //           icon:'success',
    //          }).then((result) => {
    //           console.log(result)
    //           window.location.reload()
    //         })
    //         })
    //        }
    //     });
    // },
    sortArrays(arrays) {
        return _.orderBy(arrays, 'business_category_name', 'asc');
    },
    sortbrands(arrays) {
        return _.orderBy(arrays, 'filter_name', 'asc');
    },
    


    }
  };
</script>